var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cl_logo"},[_c('router-link',{attrs:{"to":{
  name: 'brand',
  params: { storeName: _vm.$store.storeName, id: _vm.id  , name:_vm.name},
}}},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }